import React, { useEffect, useState } from 'react';
import './Cursor.css';

const CursorAnimation = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="cursor">
      <div
        className="cursor__ball cursor__ball--big"
        style={{
          transform: `translate3d(${position.x - 85}px, ${position.y - 85}px, 0)`,
        }}
      >
        <svg height="170" width="170">
          <circle cx="85" cy="85" r="13" strokeWidth="0" />
        </svg>
      </div>
    </div>
  );
};

export default CursorAnimation;